export default __webpack_public_path__ + "7a16fc6fd6d2ead8c0168f864e0b7c49.svg";